import React, {FC} from 'react'

import {
  Pagination,
  PaginationItem,
  PaginationLink
} from 'reactstrap';


const PagerList: FC<any> = (props: {pager:any, current_page: any, setPage:any, reloadList: any}) => {
	
	const getLinks = (() => {
           //CREATE LINK PAGER
	      var links = []
	      if(props.pager.pages > 1){
	      	if(props.pager.pages < 3){
		      for(var i = 0; i < props.pager.pages; i++){
			      links.push(i);
		      }
		    }else{
		      for(var i = (parseInt(props.current_page) - 1 >= 0 ? parseInt(props.current_page) - 1 : 0); (i <= parseInt(props.current_page) + 1 && i < props.pager.pages); i++){
			      links.push(i);
		      }
		    }
		    
		    return links
	      }
	      
    })
    
    const links: any = getLinks()
   
	return (
	    <>
	      
			{(props.pager && props.pager.pages > 1) &&
		          <Pagination className="pagination-second">
		            <PaginationItem disabled={props.current_page === 0}>
		              <PaginationLink first href="#" onClick={e => {
		              		e.preventDefault();
		              		props.setPage(0);
			              	props.reloadList(0)
		              	
		              	}
		              }>
		              first
		              </PaginationLink>
		            </PaginationItem>
		            <PaginationItem disabled={props.current_page === 0}>
		              <PaginationLink
		                previous
		                href="#/"
		                onClick={e => {
		              		e.preventDefault();
		              		props.setPage(props.current_page - 1);
			              	props.reloadList(props.current_page - 1)
		              	}
		              }>
		              previous
		              </PaginationLink>
		            </PaginationItem>
		            
		             {links.map((link: any, key:any) => (
						<PaginationItem key={key} active={ props.current_page === link }>
			              <PaginationLink href="#/" onClick={e => {
			              		e.preventDefault();
			              		console.log(props.current_page, link)
			              		props.setPage(link )
			              		props.reloadList(link)
			              	
			              	  }
			              	}>
			                { link + 1 }
			              </PaginationLink>
			            </PaginationItem>
			            
			        ))}
			        
		            <PaginationItem disabled={props.current_page === props.pager.pages - 1}>
		              <PaginationLink next href="#/"  onClick={e => {
		              		e.preventDefault();
		              		props.setPage( props.current_page + 1 );
			              	props.reloadList(props.current_page + 1)
		              	
		              	}
		              }>
		              next
		              </PaginationLink>
		            </PaginationItem>
		            <PaginationItem disabled={props.current_page === props.pager.pages - 1}>
		              <PaginationLink last href="#/" onClick={e => {
		              		e.preventDefault();
		              		props.setPage(props.pager.pages - 1 );
			              	props.reloadList(props.pager.pages - 1)
		              	
		              	}
		              }>
		              last
		              </PaginationLink>
		            </PaginationItem>
		          </Pagination>
		      }
		      
	    </>
  )
}

export {PagerList}
